<!-- 公共切换当前显示语言选择器弹窗组件 -->
<template>
    <van-popup v-model="show" round position="bottom">
        <van-picker show-toolbar :confirm-button-text="$t('common.confirm')" :cancel-button-text="$t('common.cancel')"
            value-key="label" :columns="columns" :default-index="defaultIndex" @cancel="cancelPicker"
            @confirm="confirmPicker" />
    </van-popup>
</template>

<script>
import { LANGUAGE_LIST } from "@/utils/constant.js";
export default {
    data() {
        return {
            show: false, // 是否显示选择器弹窗
            defaultIndex: 0, // 默认值
        };
    },
    computed: {
        // 国际化可选数据
        columns() {
            return LANGUAGE_LIST.map(item => item.label) || [];
        },
    },
    methods: {
        /**
         * 显示选择器弹窗
         */
        showPicker() {
            const currentLocale = this.$i18n.locale || "zh-CN";
            const findIndex = LANGUAGE_LIST.findIndex(item => item.value === currentLocale);
            if (findIndex > -1) {
                this.defaultIndex = findIndex;
            } else {
                this.defaultIndex = 0;
            }
            this.show = true;
        },
        /**
         * 隐藏选择器弹窗
         */
        cancelPicker() {
            this.$emit("cancel")
            this.hidePicker();
        },
        /**
         * 隐藏选择器弹窗
         */
        hidePicker() {
            this.show = false;
        },
        /**
         * 确认选择器弹窗
         */
        confirmPicker(value, index) {
            const selectedLocale = LANGUAGE_LIST[index].value;
            const selectedLocaleLabel = LANGUAGE_LIST[index].label;
            this.$i18n.locale = selectedLocale;
            this.hidePicker();
            this.$emit("changeSuccess")
            this.$toast(this.$t("tips.changeLocales", { lang: selectedLocaleLabel }),);
        },
    },
};
</script>

<style scoped></style>